import { render, staticRenderFns } from "./PartnerContractIframe.vue?vue&type=template&id=6d8aca76&"
import script from "./PartnerContractIframe.vue?vue&type=script&lang=ts&"
export * from "./PartnerContractIframe.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports